export default __webpack_public_path__ + "static/media/afiliapay.6762534e.png";